import script from "./IconSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./IconSelector.vue?vue&type=script&setup=true&lang=js"

import "./IconSelector.vue?vue&type=style&index=0&id=3837e195&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3837e195"]])

export default __exports__